import { render } from "./BrMessages.vue?vue&type=template&id=82a0ed6c&scoped=true"
import script from "./BrMessages.vue?vue&type=script&lang=js"
export * from "./BrMessages.vue?vue&type=script&lang=js"

import "./BrMessages.vue?vue&type=style&index=0&id=82a0ed6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a0ed6c"]])

export default __exports__